/**
*  料金シミュレーター
*
*  介護予防通所リハビリテーション
*
*  @since 2019.9.24
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_daycareKaigo = {
  /* 介護度に応じたサービス料 */
  shien:
  [
    // 要支援 1 : [ 1割, 2割, 3割 ]
    {
      normal: [ 6293, 8906, 11519 ],
      short : [ , , ]
    },
    // 要支援 2 : [ 1割, 2割, 3割 ]
    {
      normal: [ 12172, 16985, 21798 ],
      short : [ , , ]
    }
  ]
}



/**
*  function
*  動作
*/

// 通所リハビリテーション
$( calcBtn.rehaDaycareKaigo ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.rehaDaycareKaigo ).serializeArray();
  const selectVal = selectCheck( currentForm.rehaDaycareKaigo, formData );
  let daysExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 1日の利用時間に応じて居住費を設定
    switch( parseInt( selectVal.days, 10 ) )
    {
      // 通常（6時間以上～8時間未満）
      case 1:
        daysExpense = array_daycareKaigo.shien[ selectVal.kaigo ].normal[ selectVal.futan ];
      break;
      // 短時間（1時間以上2時間未満）
      case 2:
        daysExpense = array_daycareKaigo.shien[ selectVal.kaigo ].short[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する
    const result = parseInt( daysExpense, 10);
    $( resultElm.rehaDaycareKaigo ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始
return;
});
